module.exports = __webpack_public_path__ + "static/engineering5-zig-zag-78a8429b15193a9455899a67e236fe87.png";